import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { useState } from "react";

export default function RefundModal({ openModal, onClose }) {
  const handleCloseModal = () => {
    onClose();
  };

  const [selectedRadioValue, setSelectedRadioValue] = useState("");

  const handleChangeRadioButton = (event) => {
    setSelectedRadioValue(event.target.value);
  };

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      event.stopPropagation();
    }
  };
  return (
    <>
      <Dialog
        open={openModal}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        onClick={handleBackdropClick}
      >
        <DialogTitle sx={{ fontWeight: 500, fontSize: "32px" }}>
          Refund
          <IconButton
            aria-label="close"
            onClick={() => handleCloseModal()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#000000",
            }}
          >
            <RxCross2 />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="col-md-11">
            <div className="row">
              <div className="col-md-4 mb-3">
                <Typography style={{ fontSize: "16px", fontWeight: 500 }}>
                  Order ID
                </Typography>
                <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                  ME11011{" "}
                </Typography>
              </div>
              <div className="col-md-4 mb-3">
                <Typography style={{ fontSize: "16px", fontWeight: 500 }}>
                  Transaction ID
                </Typography>
                <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                  bdD2FU8YRq{" "}
                </Typography>
              </div>
              <div className="col-md-4 mb-3">
                <Typography style={{ fontSize: "16px", fontWeight: 500 }}>
                  Amount
                </Typography>
                <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                  $540
                </Typography>
              </div>
              <div className="col-md-4 mb-3">
                <Typography style={{ fontSize: "16px", fontWeight: 500 }}>
                  Method
                </Typography>
                <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                  Visa
                </Typography>
              </div>
              <div className="col-md-4 mb-3">
                <Typography style={{ fontSize: "16px", fontWeight: 500 }}>
                  Payment Status
                </Typography>
                <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                  Authorisation
                </Typography>
              </div>
            </div>
          </div>
          <Divider style={{ marginTop: "20px", marginBottom: "22px" }} />

          <Typography
            sx={{ fontSize: "16px", fontWeight: 500, paddingBottom: "10px" }}
          >
            Refund Amount
          </Typography>
          <RadioGroup
            value={selectedRadioValue}
            onChange={handleChangeRadioButton}
            row
          >
            <FormControlLabel value="full" control={<Radio />} label="Full" />
            <FormControlLabel
              value="partial"
              control={<Radio />}
              label="Partial"
            />
          </RadioGroup>
          <TextField
            id="outlined-basic"
            sx={{
              backgroundColor: "#F2F2F2",
              borderRadius: "6px",
              marginTop: "5px",
            }}
            size="small"
            variant="outlined"
            placeholder="$540"
          />
        </DialogContent>
        <DialogActions style={{ paddingBottom: "15px" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{
              color: "black",
              marginRight: "10px",
              textTransform: "none",
              fontSize: "18px",
              width: "234px",
              height: "64px",
              fontWeight: 600,
              borderRadius: "16px",
              border: "2px solid black",
              fontFamily: "Poppins",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              fontWeight: 600,
              backgroundColor: "black",
              borderRadius: "16px",
              textTransform: "none",
              marginRight: "10px",
              width: "236px",
              fontSize: "18px",
              width: "234px",
              height: "64px",
              border: "2px solid black",
              fontFamily: "Poppins",
            }}
          >
            Refund
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
